import posthog from "posthog-js";

export default {
  install(Vue, options) {
    // If prod environment, use prod key, else don't track
    if (process.env.NODE_ENV == "production") {
      Vue.prototype.$posthog = posthog.init(
        "phc_ineZR06S2aVScRfk695XhG9K95n1JzMC9HpuPpRL2sk",
        {
          // autocapture: false,
          api_host: "https://eu.i.posthog.com",
          person_profiles: 'identified_only',
          disable_session_recording: true,
          // cross_subdomain_cookie: false,
          // store_google: false,
          // verbose: true,
          // capture_pageview: false,
          // capture_pageleave: false,
          // debug: true,
          // disable_persistence: true,
          // disable_cookie: true,
          // disable_surveys: true,
          // disable_external_dependency_loading: true,
          // enable_recording_console_log: false,
          // capture_performance: false,
          // disable_compression: true,
          // enable_heatmaps: false,
          // disable_scroll_properties: true,
        }
      );
    }
  }
};